import { Button, Dialog, DialogActions, DialogBody, DialogContent, DialogSurface, DialogTitle, DialogTrigger } from '@fluentui/react-components';
import { useEffect, useState } from 'react';
import IPassword from '../../models/password/IPassword';
import passwordService from '../../services/passwordService';
import INewPasswordProps from './INewPasswordProps';
import NewPasswordCard from './NewPasswordCard';
import newPassword from './NewPasswordObject';
import PasswordForm from '../form/PasswordForm';
import setObjectState from '../../utilities/setObjectState';
import { useTranslation } from 'react-i18next';

export default function NewPassword(props: INewPasswordProps) {    
    const { t } = useTranslation();

    const handleChange = (key: string, value?: string) => setObjectState(setForm, key, value);

    const [form, setForm] = useState<IPassword>(newPassword(props.folderId!, props.isPersonalFolder));
    const [open, setOpen] = useState(false);

    const handleSubmit = () => {
        passwordService.createPassword(form)
          .then(() => {
            props.onSave();
            setForm(newPassword(props.folderId!));
            setOpen(false);
          })
          .catch(error => console.error(error));
      };

      useEffect(() => {
        if (!open) {
            return;
        }

        setForm(newPassword(props.folderId, props.isPersonalFolder));
    }, [open, props.folderId, props.isPersonalFolder]);

    return (
        <Dialog open={open} onOpenChange={(_, data) => setOpen(data.open)}>
            <NewPasswordCard />
            <DialogSurface>
                <DialogBody>
                    <DialogTitle>{t("passwords.titles.create")}</DialogTitle>
                    <DialogContent>
                        <PasswordForm data={form} shouldHidePersonalPassword={props.isPersonalFolder} onChange={handleChange} />
                    </DialogContent>
                    <DialogActions>
                        <DialogTrigger disableButtonEnhancement>
                            <Button appearance="secondary">
                                {t("general.cancel")}
                            </Button>
                        </DialogTrigger>
                        <Button appearance="primary" onClick={handleSubmit}>
                            {t("general.save")}
                        </Button>
                    </DialogActions>
                </DialogBody>
            </DialogSurface>
        </Dialog>
    );
}